
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ReceptionDispInfo } from "../../../../../domain/workflow";
import { ReceptionComment } from "../../../../../domain/workflow/reception";
import { ReceptionCommentSortItemKinds, ReceptionCommentUnitKinds, } from "../../../../../domain/workflow/kinds";
import { IReferenceCommentListTableCondition, IComments, IComment } from "../IReferenceCommentListTableCondition";

@Component
export default class ReferenceCommentListTableMixin extends Mixins() {
  @Prop()
  condition: IReferenceCommentListTableCondition;

  data(): any {
    return {
      nextMessageSortType: ReceptionCommentSortItemKinds.UpdateDateTime,
      backMessageSortType: ReceptionCommentSortItemKinds.UpdateDateTime,
    };
  }
  nextMessageSortType: ReceptionCommentSortItemKinds;
  backMessageSortType: ReceptionCommentSortItemKinds;

  mounted(): void {
    this.initializeSortTypes();
  }

  initializeSortTypes(): void {
    this.nextMessageSortType = this.defaultSortType;
    this.backMessageSortType = this.defaultSortType;
  }

  get labelSetting(): ReceptionDispInfo {
    return this.condition
      ? this.condition.labelSetting
      : new ReceptionDispInfo();
  }

  get nextMessageTitle(): string {
    const setting = this.labelSetting ? this.labelSetting : new ReceptionDispInfo();
    return setting.nextMessageLabelName;
  }

  get backMessageTitle(): string {
    const setting = this.labelSetting ? this.labelSetting : new ReceptionDispInfo();
    return setting.backMessageLabelName;
  }

  get comments(): IComments {
    return this.condition && this.condition.comments
      ? this.condition.comments
      : null;
  }

  get defaultSortType(): ReceptionCommentSortItemKinds {
    return this.comments && this.comments.defaultSortType
      ? this.comments.defaultSortType
      : ReceptionCommentSortItemKinds.UpdateDateTime;
  }

  get shouldSortCommentAsc(): boolean {
    return this.comments && this.comments.shouldSortCommentAsc;
  }

  get nextMessageSet(): IComment {
    return this.comments && this.comments.nextMessages
      ? this.comments.nextMessages
      : null;
  }

  get nextMessages(): ReceptionComment[] {
    return this.nextMessageSet && this.nextMessageSet.comments
      ? this.nextMessageSet.comments
      : [];
  }

  get nextMessageUnitKind(): ReceptionCommentUnitKinds {
    return this.nextMessageSet
      ? this.nextMessageSet.unit
      : ReceptionCommentUnitKinds.Single;
  }

  get backMessageSet(): IComment {
    return this.comments && this.comments.backMessages
      ? this.comments.backMessages
      : null;
  }

  get backMessages(): ReceptionComment[] {
    return this.backMessageSet && this.backMessageSet.comments
      ? this.backMessageSet.comments
      : [];
  }

  get backMessageUnitKind(): ReceptionCommentUnitKinds {
    return this.backMessageSet
      ? this.backMessageSet.unit
      : ReceptionCommentUnitKinds.Multiple;
  }
}
